module.exports = __webpack_public_path__ + "static/media/logo-white-2.0045d658.png";